<template>
  <div style="width: 100%; background: #fff; padding: 0px;">
    <mu-flex direction="row" style="height: 8rem">
    <!-- <mu-flex class="flex-wrapper" justify-content="start"> -->

        <div style="width: 100%;height: 100%;background-color: #fff;">
          <!-- text-align: center; -->
          <p v-if="CurrentData.sH <= 0" style="width: 100%;height: 1.75rem;margin-left: 8px;margin-top: 0.5rem;font-size: 2.8125rem;color: #aa2116;">
            {{CurrentData.bidPx}}
          </p>
          <p v-if="CurrentData.sH > 0" style="width: 100%;height: 1.75rem;margin-left: 8px;margin-top: 0.5rem;font-size: 2.8125rem;color: #225a1f;">
            {{CurrentData.bidPx}}
          </p>
          <!-- <p
            style="width: 100%;height: 1.75rem;margin-left: 8px;margin-top: 0.5rem;font-size: 2.8125rem;color: #aa2116;">
            {{CurrentData.bidPx}}
          </p> -->
          <p v-if="CurrentData.sH <= 0"
            style="width: 100%;height: 1.75rem;margin-left: 8px;margin-top: 0.1rem;font-size: 1.8125rem;color: #aa2116;">
            {{CurrentData.sH}}%
          </p>
          <p v-if="CurrentData.sH > 0"
            style="width: 100%;height: 1.75rem;margin-left: 8px;margin-top: 0.1rem;font-size: 1.8125rem;color: #225a1f;">
            {{CurrentData.sH}}%
          </p>
        </div>
        <div style="width: 100%;height: 100%;background-color: #fff;">
          <p
            style="width: 100%;height: 1rem;margin-top: 1.8rem;font-size: 1rem;color: #313131;">
            <font color="#B1B1B1">High(24h) </font>{{CurrentData.high24h}}
          </p>
          <p
            style="width: 100%;height: 1rem;margin-top: 0.1rem;font-size: 1rem;color: #313131;">
            <font color="#B1B1B1">Low(24h) </font>{{CurrentData.low24h}}
          </p>
          <p
            style="width: 100%;height: 1rem;margin-top: 0.1rem;font-size: 1rem;color: #313131;">
            <font color="#B1B1B1">Quantity(24h) </font>{{CurrentData.open24h}}
          </p>
        </div>
      <!-- <mu-flex class="flex-demo" justify-content="center" >left</mu-flex> -->
    <!-- </mu-flex> -->
    <!-- <mu-flex class="flex-wrapper" justify-content="center">
      <mu-flex class="flex-demo" justify-content="center" >center</mu-flex>
    </mu-flex> -->
   <!-- <mu-flex class="flex-wrapper" justify-content="end">
        <div style="width: 100%;height: 31.25rem;background-color: #000040;"></div>
    </mu-flex> -->

    </mu-flex>
<!--    <mu-flex class="flex-wrapper" align-items="center">
      <mu-flex class="flex-demo" justify-content="center" fill>fill</mu-flex>
      <mu-flex class="flex-demo" justify-content="center" fill>fill</mu-flex>
      <mu-flex class="flex-demo" justify-content="center" fill>fill</mu-flex>
    </mu-flex> -->
  </div>
</template>

<script>
  // export function setCurrentData(data) {
  //       // this.CurrentData = data;
  //       console.log(":::::::::");
  //     }
  export default {
    data() {
      return {
        CurrentData: {}
      }
    },
    mounted() {
      // window.T_Details_Head = this;
      //   console.log(":::::::::"+this.CurrentData);
    },
    methods: {
      setCurrentData(data) {
        this.CurrentData = data;
        // console.log(":::::::::"+this.CurrentData);
      }
    },
    components: {
    }
  };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/OK_Scott/components/Transaction/Details/T_Details_Head.vue